import { cn } from '@/lib/utils'

interface MonoMarkProps {
  className?: string
  /** Accessible name; decorative when omitted (the text beside it carries the meaning). */
  label?: string
}

/**
 * The cathedral mark in one colour (`currentColor` ink), from `<symbol id="mark-mono">` in
 * index.html. 24 px in empty states, 64 px on the splash and the second-tab screen; the
 * colour mark (`/brand/logo-katedral-baru.svg`) is reserved for the header and the login
 * screen. Size it with a size utility (`size-6`, `size-16`); the symbol carries the viewBox,
 * so the svg itself must not repeat it (a <use> of a symbol renders at the user-space origin).
 */
export function MonoMark({ className, label }: MonoMarkProps) {
  const classes = cn('shrink-0 fill-current', className)
  if (label === undefined) {
    return (
      <svg className={classes} aria-hidden="true" focusable="false">
        <use href="#mark-mono" />
      </svg>
    )
  }
  return (
    <svg className={classes} role="img" focusable="false">
      <title>{label}</title>
      <use href="#mark-mono" />
    </svg>
  )
}
